module.exports = __webpack_public_path__ + "img/receive_03.png";